import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { brandService } from '../../services/brandService';

export const useGetFounderDetail = id => {
  return useQuery({
    staleTime: Infinity,
    queryKey: [QUERY_KEYS.brand.founder_detail, id],
    queryFn: () =>
      brandService.founderDetail(id).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        throw new Error('Fetch failed');
      }),
  });
};
